import { Routing } from '../Routes';
import { Main } from '../Main/Main';
import { Redirect } from 'react-router';
import { useSession } from '../../state/session';
import { LoginCard } from '../App/LoginModal';

export const LoginPage = (): JSX.Element => {
	const { isLoggedIn } = useSession();

	return (
		<Main>
			{isLoggedIn && <Redirect to="/" />}
			<LoginCard />
		</Main>
	);
};

export const loginRouting: Routing = {
	path(urls) {
		return urls.login;
	},
	component: LoginPage,
	requiresAuth: false,
};
